// custom-notification.service.ts
import { Injectable, signal } from '@angular/core';
import { eTypeNotificationTemplate } from '../constants/options'; // Ajusta la ruta

export interface AppNotification {
    _id: string;
    title: string;
    description: string;
    themeColor: string;      // Color sólido para el borde y el ícono
    backgroundColor: string; // Color con 1A al final para el fondo
    icon: string;
    raw: any;
}

@Injectable({
    providedIn: 'root'
})
export class CustomNotificationService {
    public notifications = signal<AppNotification[]>([]);

    public show(data: any) {
        let themeColor = data.template?.color;

        // Si no hay color personalizado, usamos los de la plantilla
        if (!themeColor) {
            switch (data.template?.notification_type) {
                case eTypeNotificationTemplate.Success: themeColor = '#22c55e'; break; // Verde
                case eTypeNotificationTemplate.Error: themeColor = '#ef4444'; break;   // Rojo
                case eTypeNotificationTemplate.Warning: themeColor = '#f59e0b'; break; // Amarillo/Naranja
                case eTypeNotificationTemplate.Info: themeColor = '#3b82f6'; break;    // Azul
                default: themeColor = '#3b82f6'; break;                                // Azul por defecto
            }
        }

        let cleanDescription = data.notification?.description || '';
        if (cleanDescription) {
            cleanDescription = cleanDescription.replace(/&nbsp;/g, ' ');
        }

        const newNotification: AppNotification = {
            _id: Math.random().toString(36).substring(2, 9),
            title: data.notification?.title || 'Notificación',
            description: cleanDescription,
            themeColor: themeColor,
            backgroundColor: `${themeColor}1A`, // Agregamos 10% de opacidad
            icon: data.template?.icon || 'pi pi-bell',
            raw: data
        };

        this.notifications.update((current) => [...current, newNotification]);

        setTimeout(() => {
            this.remove(newNotification._id);
        }, 3000);
    }

    public remove(id: string) {
        this.notifications.update((current) => current.filter(n => n._id !== id));
    }
}